import {ButtonGroup, createListCollection, Heading, IconButton, Pagination, Portal, Select, Show, Stack, Table} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {dataApi, Expense, Income} from "../../api/data-api";
import {DateTime} from "luxon";
import {useToast} from "@chakra-ui/toast";
import {LuChevronLeft, LuChevronRight} from "react-icons/lu";
import {errorNotify} from "../../components/hooks/CommonUtils";

export const History = () => {
    const [items, setItems] = useState<Income[] | Expense[]>([]);
    const toast = useToast();
    const [typeDirection, setTypeDirection] = useState<"IN" | "OUT">("IN");
    const [count, setCount] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const pageSize = 10;

    useEffect(() => {
        if (typeDirection === "IN") {
            dataApi.incomeListCount()
                .then(o => {
                    if (o && o > 0)
                        setCount(o as number);
                })
                .catch((err) => errorNotify(err, toast));
        } else if (typeDirection === "OUT") {
            dataApi.expenseListCount()
                .then(o => {
                    if (o && o > 0)
                        setCount(o as number);
                })
                .catch((err) => errorNotify(err, toast));
        }
    }, [toast, typeDirection]);
    useEffect(() => {
        if (typeDirection === "IN") {
            dataApi.incomeList((currentPage - 1) * pageSize, pageSize)
                .then(o => {
                    if (o)
                        setItems(o);
                })
                .catch((err) => errorNotify(err, toast));
        } else if (typeDirection === "OUT") {
            dataApi.expenseList((currentPage - 1) * pageSize, pageSize)
                .then(o => {
                    if (o)
                        setItems(o);
                })
                .catch((err) => errorNotify(err, toast));
        }
    }, [count, currentPage, toast, typeDirection]);

    const historyDirectionTypes = createListCollection({
        items: [
            {label: "Income", value: "IN"},
            {label: "Outcome", value: "OUT"},
        ],
    });
    return (
        <Stack width="full" gap="5">
            <Heading size="xl">History</Heading>
            <Select.Root defaultValue={[typeDirection]} collection={historyDirectionTypes} size="sm" width="320px"
                         onChange={(e: any) => setTypeDirection(e.target.value)}>
                <Select.HiddenSelect/>
                <Select.Control>
                    <Select.Trigger>
                        <Select.ValueText placeholder="DirectionType"/>
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                        <Select.Indicator/>
                    </Select.IndicatorGroup>
                </Select.Control>
                <Portal>
                    <Select.Positioner>
                        <Select.Content>
                            {historyDirectionTypes.items.map((it: any) => (
                                <Select.Item item={it} key={it.value}>
                                    {it.label}
                                    <Select.ItemIndicator/>
                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select.Positioner>
                </Portal>
            </Select.Root>
            <Table.Root size="sm" variant="outline" striped>
                <Table.Header>
                    <Table.Row>
                        <Table.ColumnHeader>Тип</Table.ColumnHeader>
                        <Show when={typeDirection === 'IN'}>
                            <Table.ColumnHeader>From user id</Table.ColumnHeader>
                        </Show>
                        <Show when={typeDirection === 'OUT'}>
                            <Table.ColumnHeader>To user id</Table.ColumnHeader>
                        </Show>
                        <Table.ColumnHeader>Payout id</Table.ColumnHeader>
                        <Show when={typeDirection === 'OUT'}>
                            <Table.ColumnHeader>Документ</Table.ColumnHeader>
                        </Show>
                        <Table.ColumnHeader>Value</Table.ColumnHeader>
                        <Table.ColumnHeader>External id</Table.ColumnHeader>
                        <Table.ColumnHeader>Comments</Table.ColumnHeader>
                        <Table.ColumnHeader>Создан</Table.ColumnHeader>
                        <Show when={typeDirection === 'OUT'}>
                            <Table.ColumnHeader>Изменен</Table.ColumnHeader>
                            <Table.ColumnHeader>Подтвержден</Table.ColumnHeader>
                            <Table.ColumnHeader>Отменен</Table.ColumnHeader>
                        </Show>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {items.map((item) => (
                        <Table.Row key={item.ID}>
                            <Table.Cell>{item.TYPE1}</Table.Cell>
                            <Table.Cell>{typeDirection === 'IN' ? (item as Income).FROM_USER_ID : (item as Expense).TO_USER_ID}</Table.Cell>
                            <Table.Cell>{item.PAYOUT_ID}</Table.Cell>
                            <Show when={typeDirection === 'OUT'}>
                                <Table.Cell>{(item as Expense).DOCUMENT_ID}</Table.Cell>
                            </Show>
                            <Table.Cell>{item.VALUE1}</Table.Cell>
                            <Table.Cell>{item.EXTERNAL_ID}</Table.Cell>
                            <Table.Cell>{item.COMMENTS}</Table.Cell>
                            <Table.Cell>{item.CREATED ? DateTime.fromMillis(item.CREATED).toFormat('HH:mm:ss dd.MM.yyyy') : ""}</Table.Cell>
                            <Show when={typeDirection === 'OUT'}>
                                <Table.Cell>{(item as Expense).VERSION ? DateTime.fromMillis((item as Expense).VERSION).toFormat('HH:mm:ss dd.MM.yyyy') : ""}</Table.Cell>
                                <Table.Cell>{(item as Expense).CONFIRMED ? DateTime.fromMillis((item as Expense).CONFIRMED).toFormat('HH:mm:ss dd.MM.yyyy') : ""}</Table.Cell>
                                <Table.Cell>{(item as Expense).REJECTED ? DateTime.fromMillis((item as Expense).REJECTED).toFormat('HH:mm:ss dd.MM.yyyy') : ""}</Table.Cell>
                            </Show>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table.Root>

            <Pagination.Root count={count} pageSize={pageSize} page={currentPage}>
                <ButtonGroup variant="ghost" size="sm" wrap="wrap">
                    <Pagination.PrevTrigger asChild>
                        <IconButton>
                            <LuChevronLeft/>
                        </IconButton>
                    </Pagination.PrevTrigger>

                    <Pagination.Items
                        render={(page) => (
                            <IconButton variant={{base: "ghost", _selected: "outline"}} onClick={e => setCurrentPage(page.value)}>
                                {page.value}
                            </IconButton>
                        )}
                    />

                    <Pagination.NextTrigger asChild>
                        <IconButton>
                            <LuChevronRight/>
                        </IconButton>
                    </Pagination.NextTrigger>
                </ButtonGroup>
            </Pagination.Root>

        </Stack>
    );
};